import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import TB2 from "../../components/ExcerciseTypes/Table/TB2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write3 from "../../components/ExcerciseTypes/Circle_Write3";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write3";

const json = {
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    // audio: "Audios/bt_fpt_ai/p24_intro.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page30/Key/E3answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 2,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      textAlign: "center",
      background: "none",
      fontSize: 24,
      textTransform: "uppercase",
    },
    inputSize: 80,
    titleQuestion: [
      {
        num: "3",
        title: `Viết tiếp vào chỗ chấm thích hợp (theo mẫu).<br> Quan sát các mặt đồng hồ sau và cho biết trong các đồng hồ đó, khi nào kim giờ và kim phút tạo thành góc nhọn, góc vuông, góc tù và góc bẹt.
		    `,
        color: "rgb(99,197,244)",
      },
    ],
    colorWhite:true,
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
          Nháy chuột vào chỗ chấm để điền câu trả lời thích hợp.
        </span>
        <video src="Audios/bt_fpt_ai/guide/p30_e1.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative; line-height: 50px'>
          <img src='/img/FriendsPlus/Page30/E3/1.jpg' style='height:7cm; width: 26cm; margin-bottom: 30px'/><br>
          <div><span style='color: rgb(99,197,244)'>Mẫu: </span>Lúc 3 giờ, kim giờ và kim phút tạo thành góc vuông.</div>
        	<div style=''>Lúc <input id= "0"> giờ, kim giờ và kim phút tạo thành góc nhọn.</div>
          <div style=''>Lúc <input id= "1"> giờ, kim giờ và kim phút tạo thành góc tù.</div>
          <div style=''>Lúc <input id= "2"> giờ, kim giờ và kim phút tạo thành góc bẹt.</div>
        
        </div>
        `,
        answer: ["1", "8", "6"],
      },
    ],
  },
  4: {
    unit: "Review 2",
    id: "4WB-R2-P49-E5",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page30/Key/E4answerKey.png",
    component: Circle_Write,
    // checkUppercase: true,
    isHiddenCheck: true,
    titleQuestion: [
      {
        num: "4",
        title: `
      			Miệng của chiếc hộp đựng dế than, dế lửa và dế út tiêu có dạng là các hình tứ giác như hình sau.
      		  `,
        color: "rgb(99,197,244)",
      },
    ],
   
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
       
       a) Nháy chuột vào chỗ chấm để điền tên hình tứ giác có nhiều góc nhọn nhất.<br>
       b) Nháy chuột vào hình thích hợp để khoanh.

        </span>
        <video src="Audios/bt_fpt_ai/guide/p30_e2.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    question: {
      Write: {
        isHiddenCheck: true,
        maxLength: 10,
        inputStyle: {
          width: 250,
          fontSize: 24,
          textAlign: "center",
          height: 29,
          paddingBottom: 10,
          textTransform: "uppercase",
        },
        answers: ["ABCD"],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 69,
          borderRadius: "50%",
          border: "3px solid white",
          fontSize: 25,
          marginRight: 23,
          borderColor: "transparent",
          fontWeight: "bold",
          color: "transparent",
        },
        selectWordStyle: {
          border: "3px solid white",
          padding: "69px 70px",
          borderColor: "#00aeef",
          color: "transparent",
        },
        limitSelect: 1,
        listWords: [
          `I1111 &ensp;&ensp;&ensp;&ensp;&ensp; they1 &ensp;&ensp;&ensp;&ensp;&ensp; they1`, //0
        ],
        answers: ["0-4"],
        initialValue: [],
      },
      Layout: `
      <div style='position: relative; max-width: 1500px;  margin-bottom: 350px'>

      <img src='img/FriendsPlus/Page30/E4/1.jpg' style='width: 25cm; height: 6cm'>
        
        <div style=" position: absolute; top: 97px; left: 73px; width: max-content"><input id='0' type='Circle'/></div>

        <div style=" position: absolute; margin-top: 43px ">
          <div><b>a) Viết tiếp vào chỗ chấm cho thích hợp.</b><br>
          Hình tứ giác có nhiều góc nhọn nhất là: <input id='0'></input>
          </div><br>

          <div><b>b) Biết miệng chiếc hộp đựng dế út tiêu có cả góc vuông, góc tù và góc nhọn.<br> Em hãy khoanh vào hình là miệng chiếc hộp ấy.</b><br>
          </div>

        </div>

        
	    </div>
      `,
    },
  },
};

export default json;
